var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { create } from '../Style';
export default create({
  hook: function hook(style) {
    return _extends({
      pointerEvents: 'none'
    }, style);
  }
});